module.exports = __webpack_public_path__ + "img/result2.13551e06.png";